import { render, staticRenderFns } from "./_requisicoes.tab.vue?vue&type=template&id=05bf3fab&scoped=true"
import script from "./_requisicoes.tab.vue?vue&type=script&lang=js"
export * from "./_requisicoes.tab.vue?vue&type=script&lang=js"
import style0 from "./_requisicoes.tab.vue?vue&type=style&index=0&id=05bf3fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf3fab",
  null
  
)

export default component.exports